import styled from 'styled-components';

export const FAButtonWrapper = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 5px;
  cursor: pointer;
  transform-origin: center;
  
  display:flex;
  align-items: center;
  align-content: center;

  :hover {
    background-color: #40404080;
  }

  * {
    transform-origin: center;
    margin: 0 auto;
  }
`;